// Sub menu structures
import { InvestmentsSubMenu } from "@/components/navigation/InvestmentsSubMenu"
import { FinanceSubMenu } from "@/components/navigation/FinanceSubMenu"
import { StatsSubMenu } from "@/components/navigation/StatsSubMenu"
import { ProfileSubMenu } from "@/components/navigation/sub/ProfileSubMenu"

/**
 * Nav
 * @returns
 */
export function MainNavigation() {
	return (
		<nav className="mt-8 space-y-1 px-1 pb-4">
			<StatsSubMenu />
			<InvestmentsSubMenu />
			<ProfileSubMenu />
			<FinanceSubMenu />
		</nav>
	)
}
